// extracted by mini-css-extract-plugin
export var grid = "_29-0";
export var span1 = "_29-2";
export var span10 = "_29-b";
export var span10L = "_29-z";
export var span10M = "_29-n";
export var span10Xl = "_29-1b";
export var span11 = "_29-c";
export var span11L = "_29-10";
export var span11M = "_29-o";
export var span11Xl = "_29-1c";
export var span12 = "_29-d";
export var span12L = "_29-11";
export var span12M = "_29-p";
export var span12Xl = "_29-1d";
export var span1L = "_29-q";
export var span1M = "_29-e";
export var span1Xl = "_29-12";
export var span2 = "_29-3";
export var span2L = "_29-r";
export var span2M = "_29-f";
export var span2Xl = "_29-13";
export var span3 = "_29-4";
export var span3L = "_29-s";
export var span3M = "_29-g";
export var span3Xl = "_29-14";
export var span4 = "_29-5";
export var span4L = "_29-t";
export var span4M = "_29-h";
export var span4Xl = "_29-15";
export var span5 = "_29-6";
export var span5L = "_29-u";
export var span5M = "_29-i";
export var span5Xl = "_29-16";
export var span6 = "_29-7";
export var span6L = "_29-v";
export var span6M = "_29-j";
export var span6Xl = "_29-17";
export var span7 = "_29-8";
export var span7L = "_29-w";
export var span7M = "_29-k";
export var span7Xl = "_29-18";
export var span8 = "_29-9";
export var span8L = "_29-x";
export var span8M = "_29-l";
export var span8Xl = "_29-19";
export var span9 = "_29-a";
export var span9L = "_29-y";
export var span9M = "_29-m";
export var span9Xl = "_29-1a";
export var stretch = "_29-1";